import React from 'react'
import PropTypes from 'prop-types'
import { Chip as MuiChip } from '@mui/material'

const Chip = ({ label, icon, variant, ...restProps }) => (
  <MuiChip label={label} icon={icon} variant={variant} {...restProps} />
)

Chip.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  variant: PropTypes.string,
}

Chip.defaultProps = {
  icon: null,
  variant: 'outlined',
}

export default Chip
